import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { userStore } from '~/stores';

import EmptyList from './Empty';
import styles from './History.module.scss';
import TransactionItem from './TransactionItem';

const History = () => {
  const { t } = useTranslation();

  const loyaltyPointsTransactionsList =
    userStore.loyaltyPointsStore.loyaltyPointsTransactionsList;

  if (!loyaltyPointsTransactionsList.length) {
    return <EmptyList />;
  }

  return (
    <div className={styles.fullProgress}>
      <p className={styles.title}>{t('loyalty:progress:full:title')}</p>
      <ul className={styles.transactionList}>
        {loyaltyPointsTransactionsList.map((transaction) => (
          <TransactionItem
            key={transaction.id}
            as="li"
            transaction={transaction}
            interactive
          />
        ))}
      </ul>
    </div>
  );
};

export default observer(History);
